var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h_doc"},[_c('a-tooltip',{attrs:{"title":_vm.$t('login.help.download')}},[_c('a-icon',{staticClass:"down_btn",attrs:{"type":"download"},on:{"click":_vm.handleDown}})],1),_c('div',{ref:"file"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }